import React from 'react';
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import { SpecialKeys, useAmplitudeTracking, useFirstTimeInstructions, useIsMobileDimensions, useKeyboardInput, useOrientationChange, usePageVisibilityPause, useStructuredDataEmbedding } from '../shared/utils';
import { ArithmeglyphsStore } from './ArithmeglyphsStore';
import { handleInput, saveArithmeglyphs, shouldDisableZeroButton } from './arithmeglyphsUtils';
import GlyphSequence from './components/GlyphSequence';
import { PuzzleNames } from '../../../utils/types';
import PauseCover from '../shared/PauseCover';
import ArithmeglyphsTopBar from './components/ArithmeglyphsTopBar';
import { isMobile } from 'react-device-detect';
import GlyphReference from './components/GlyphReference/GlyphReference';
import { usePuzzleTracking } from '../../../utils/usePuzzleTracking';
import './Arithmeglyphs.less';

const Arithmeglyphs = () => {
  const { solved, completed, dataByLine, thirdLineNumSeq, focusLocation }
    = ArithmeglyphsStore.useState();

  // It's intended to take `revealed` & `solved`, but arithmeglyphs only uses `completed`,
  // so I'm just passing that for both those params so I don't have to make a separate hook.
  useKeyboardInput(handleInput, completed, completed);
  useOrientationChange();
  useFirstTimeInstructions(PuzzleNames.Arithmeglyphs, ArithmeglyphsStore as any);
  usePageVisibilityPause(ArithmeglyphsStore as any, saveArithmeglyphs);
  useStructuredDataEmbedding(PuzzleNames.Arithmeglyphs);
  useAmplitudeTracking(PuzzleNames.Arithmeglyphs);
  usePuzzleTracking(PuzzleNames.Arithmeglyphs);

  const isLandscape = window.innerWidth > window.innerHeight && window.innerHeight < 500;
  const useMobileDimensions = useIsMobileDimensions() || isMobile;
  const disableZeroButton = !completed && shouldDisableZeroButton(focusLocation);

  return (
    <>
      <ArithmeglyphsTopBar/>
      <div className={`puzzleContainer arithmeglyphsContainer ${useMobileDimensions ? 'mobile' : ''} ${isLandscape ? 'landscape' : ''}`}>
        <GlyphReference/>

        <div className={`glyphSequencesContainer ${solved ? 'solved' : ''}`}>
          <GlyphSequence glyphString={dataByLine[0].opSeq} lineNumber={0} />
          <GlyphSequence glyphString={dataByLine[1].opSeq} lineNumber={1} />
          <div className="thirdLine">
            {thirdLineNumSeq.split('').map((digit, i) => (
              <div className="thirdLineDigit" key={i}>
                {digit}
              </div>
            ))}
          </div>
        </div>

        <button className="referenceToggle" onClick={() => {
          ArithmeglyphsStore.update(s => { s.glyphReferenceIsOpen = !s.glyphReferenceIsOpen; });
        }}>[ View Glyph Reference ]</button>

        <div className="inputPanel">
          <div className="numbersGrid">
            <div className="button" onClick={() => handleInput('1', false)}>1</div>
            <div className="button" onClick={() => handleInput('2', false)}>2</div>
            <div className="button" onClick={() => handleInput('3', false)}>3</div>
            <div className="button" onClick={() => handleInput('4', false)}>4</div>
            <div className="button" onClick={() => handleInput('5', false)}>5</div>
            <div className="button" onClick={() => handleInput('6', false)}>6</div>
            <div className="button" onClick={() => handleInput('7', false)}>7</div>
            <div className="button" onClick={() => handleInput('8', false)}>8</div>
            <div className="button" onClick={() => handleInput('9', false)}>9</div>
            <div className={`button ${disableZeroButton ? 'disabled' : ''}`} onClick={() => {
              if (disableZeroButton) return;
              handleInput('0', false)
            }}>0</div>
            {isLandscape &&
              <div className="backspace" onClick={() => handleInput(SpecialKeys.Delete, false)}>
                <BackspaceOutlinedIcon/>
              </div>
            }
          </div>
          {!isLandscape &&
            <div className="backspace" onClick={() => handleInput(SpecialKeys.Delete, false)}>
              <BackspaceOutlinedIcon/>
            </div>
          }
        </div>

        <PauseCover store={ArithmeglyphsStore as any}/>
      </div>
    </>
  );
};

export default Arithmeglyphs;